import React from 'react';
import {ITPColorsLegend} from "../constants";
const LinearChart = ({
                         score = 4.8,
                         min = 1,
                         max = 5,
                         show_score_only = false,
                         chart_height = 'h-5/12',
                         chart_width = 'w-full',
                         score_position = '30%' }) => {
    const {red, orange, yellow, lime, green} = ITPColorsLegend;
    const stops = [
        { pos: '17%', color: red.color, separator: '37%' },
        { pos: '51%', color: orange.color, separator: '52%' },
        { pos: '61%', color: yellow.color, separator: '72%' },
        { pos: '87%', color: lime.color, separator: '85%' },
        { pos: '100%', color: green.color },
    ];
    const gradientStops = [
        { pos: '0%', color: red.color }, // anchor
        ...stops,
    ];

    const pct = ((score - min) / (max - min)) * 100;
    const clamped = Math.min(Math.max(pct, 0), 100);

    const segments = gradientStops.slice(1).map((stop, i) => ({
        start: parseFloat(gradientStops[i].pos),
        end:   parseFloat(stop.pos),
        color: stop.color,
        separator: parseFloat(stop.separator),
    }));

    let scoreIndicatorPadding = clamped-3;
    scoreIndicatorPadding = `${scoreIndicatorPadding > 0 ? scoreIndicatorPadding : 0}%`;

    const fullGradient = `linear-gradient(to right, ${
        gradientStops.map(s => `${s.color} ${s.pos}`).join(', ')
    })`;

    const grayBg = '#E5E7EB';
    const chartHeightClassName = `${chart_height} relative overflow-hidden justify-items-center`
    const chartWidthClassName = `${chart_width} h-16 relative`
    return (
        <div className={chartWidthClassName} key={Math.random()}>
            <div className={chartHeightClassName}>
                {show_score_only ? (
                    <>
                        {/* 1) gray base bar */}
                        <div
                            className="h-full w-full rounded-full"
                            style={{ background: grayBg }}
                        />

                        {/* 2) full gradient bar, but clipped exactly between the two vertical separators */}
                        {(() => {
                            // 1. compute raw % score
                            const pct = Math.trunc(((score - min) / (max - min)) * 100);
                            const clamped = Math.min(Math.max(pct, 0), 100);

                            // 2. turn your stops[].separator strings into numbers, default last to 100
                            const separators = stops.map((s, i) =>
                                i === stops.length - 1 ? 100 : parseFloat(s.separator)
                            );

                            // 3. find which segment we’re in
                            const activeIndex = separators.findIndex((sep, i) => {
                                const leftBound = i === 0 ? 0 : separators[i - 1];
                                const rightBound = sep;
                                return clamped >= leftBound && clamped <= rightBound;
                            });

                            // 4. left & right clip values
                            const clipLeft = activeIndex === 0 ? 0 : separators[activeIndex - 1];
                            const clipRight =
                                activeIndex === separators.length - 1
                                    ? 100
                                    : separators[activeIndex];

                            // 5. build our clip-path
                            const insetRight = 100 - clipRight; // amount to cut off the right
                            const clipPath = `inset(0% ${insetRight}% 0% ${clipLeft}%)`;

                            return (
                                <div
                                    className="absolute top-0 left-0 h-full w-full rounded-full"
                                    style={{
                                        background: fullGradient,
                                        clipPath,
                                    }}
                                />
                            );
                        })()}
                    </>
                ) : (
                    <div
                        className="h-full w-full rounded-full"
                        style={{ background: fullGradient }}
                    />
                )}


                {stops.slice(0, -1).map((s, index) => {
                    return (
                        <div
                            key={index}
                            className="absolute top-0 h-full w-[2px] bg-white"
                            style={{ left: s.separator}}
                        />
                    );
                })}
            </div>

            <div
                className="absolute text-black text-sm text-center"
                style={{ left: `calc(${scoreIndicatorPadding})`, bottom: `calc(${score_position})`}}
            >
                <div className="flex flex-col items-center">
                    <div
                        className="w-0 h-0"
                        style={{
                            borderLeft: '10px solid transparent',
                            borderRight: '10px solid transparent',
                            borderBottom: '20px solid black',
                        }}
                    ></div>
                    <div className="font-bold text-[12pt]">{score}</div>
                </div>
            </div>
        </div>
    );
};

export default LinearChart;